import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { font } from '../Font/Font.styles';
import type { AlertStyleProps, AlertVariantsMap } from './AlertMessage.types';

const variantsMap: AlertVariantsMap = {
  success: {
    default: {
      backgroundColor: 'var(--color-success-light)',
      color: 'var(--color-neutral-70);',
      borderColor: 'var(--color-success-dark)',
      borderRadius: '0 var(--spacing-8) var(--spacing-8) 0',
    },
  },
  error: {
    default: {
      backgroundColor: 'var(--color-status-error-light)',
      color: 'var(--color-neutral-70)',
      borderColor: 'var(--color-status-error-dark)',
      borderRadius: '0 var(--spacing-8) var(--spacing-8) 0',
    },
  },
  info: {
    default: {
      backgroundColor: 'var(--color-information-light)',
      color: 'var(--color-neutral-70)',
      borderColor: 'var(--color-information-dark)',
      borderRadius: 'var(--border-radius-s)',
    },
  },
};

const commonStyles = ({ variant }: AlertStyleProps) => css`
  ${font('body-lg')};
  background-color: ${variantsMap[variant].default.backgroundColor};
  color: ${variantsMap[variant].default.color};
  border-left: var(--spacing-4) solid
    ${variantsMap[variant].default.borderColor};
  padding: var(--spacing-12);
  border-radius: ${variantsMap[variant].default.borderRadius};
  display: flex;
  align-items: center;
  gap: var(--spacing-12);

  svg {
    min-width: var(--spacing-24);
  }
`;

export const StyledAlertMessage = styled.div<AlertStyleProps>`
  ${commonStyles}
`;
